module.exports = "/_next/static/images/alerts-4bac8f5cdf7729508792f3c3b42f1c5f.png";